import { useEffect, useState } from 'react';
import { useGameStore } from '../../core/store';
import { MobileTouchControls } from './mobile/MobileTouchControls';
import './run-hud-mobile.css';

/** Compact run meters + visible touch controls. */
export function RunHUDMobile() {
  const unlocked = useGameStore((s) => s.unlockedSkills);
  const [meters, setMeters] = useState(0);
  const [stamina, setStamina] = useState(1);
  const [combo, setCombo] = useState(1);

  useEffect(() => {
    const id = window.setInterval(() => {
      setMeters((m) => m + 1);
      setStamina((s) => {
        const next = s - 0.008;
        return next < 0.22 ? 0.9 : next;
      });
      setCombo((c) =>
        unlocked.length > 0 ? Math.min(8, unlocked.length + 1) : c,
      );
    }, 200);
    return () => window.clearInterval(id);
  }, [unlocked.length]);

  const segs = 8;
  const lit = Math.round(stamina * segs);

  return (
    <div className="run-m">
      <div className="run-m__top">
        <div className="run-m__stamina" aria-label="Stamina">
          {Array.from({ length: segs }, (_, i) => (
            <span key={i} className={i < lit ? 'is-on' : ''} />
          ))}
        </div>
        <div className="run-m__meta">
          <span>{meters}m</span>
          <span className={combo > 1 ? 'is-hot' : ''}>x{combo}</span>
        </div>
      </div>

      {unlocked.length > 0 && (
        <div className="run-m__skills">
          {unlocked.slice(0, 4).map((id) => (
            <span key={id}>{id}</span>
          ))}
        </div>
      )}

      <MobileTouchControls showPower />
    </div>
  );
}
